import type { CnFunction } from 'cn'
import { createCn } from 'cn/config'

const customSpacing = ['xs', 'sm', 'md', 'lg', 'xl', '2xl']

export const cn: CnFunction = createCn({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            '3xs',
            '2xs',
            'xs',
            'sm',
            'base',
            'md',
            'lg',
            'title-xs',
            'title-sm',
            'title-md',
            'title-lg',
            'title-xl'
          ]
        }
      ],
      p: [{ p: customSpacing }],
      px: [{ px: customSpacing }],
      py: [{ py: customSpacing }],
      pt: [{ pt: customSpacing }],
      pr: [{ pr: customSpacing }],
      pb: [{ pb: customSpacing }],
      pl: [{ pl: customSpacing }],
      m: [{ m: customSpacing }],
      mx: [{ mx: customSpacing }],
      my: [{ my: customSpacing }],
      mt: [{ mt: customSpacing }],
      mr: [{ mr: customSpacing }],
      mb: [{ mb: customSpacing }],
      ml: [{ ml: customSpacing }],
      gap: [{ gap: customSpacing }],
      'gap-x': [{ 'gap-x': customSpacing }],
      'gap-y': [{ 'gap-y': customSpacing }]
    }
  }
})
